"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));
var types = _interopRequireWildcard(require("./types"));
var _array = require("../../utils/array");
var _types2 = require("../session/types");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  loaded: false,
  // Set as true when the list of rooms (in the left menu/tabbar) is loaded

  items: [],
  // list of room the user can join
  ringing: [],
  // list of rooms currently ringing
  ended: [],
  // list of rooms currently ended
  currentByUser: [],
  // list of rooms where the _user is currently in ()
  currentByClient: [],
  // list of rooms where the _client is currently in ()

  _currentActive: undefined // used by client to keep track of which room is active
};

var roomReducer = function roomReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cloneDeep.default)(initialState);
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case types.SET_ROOMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaded: true,
        items: (0, _array.flatUniqConcat)([], ...action._rooms)
      });
    case types.ADD_ROOMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: (0, _array.flatUniqConcat)(state.items, ...action._rooms)
      });
    case types.ROOM_ENDED_ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        ended: (0, _array.concatTwoArraysAsUniqByKey)(action.rooms, state.ended, 'id').slice(-5)
      });
    case types.ROOM_ENDED_REMOVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        ended: state.ended.filter(_ref => {
          var {
            id
          } = _ref;
          return !action._rooms.includes(id);
        }),
        _currentActive: undefined
      });
    case types.ROOM_RINGING_ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: (0, _array.flatUniqConcat)(state.items, ...action._rooms),
        ringing: (0, _array.flatUniqConcat)(state.ringing, ...action._rooms)
      });
    case types.ROOM_RINGING_REMOVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        ringing: state.ringing.filter(_room => !action._rooms.includes(_room))
      });
    case types.ROOM_CURRENT_CLIENT_ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: (0, _array.flatUniqConcat)(state.items, ...action._rooms),
        currentByClient: (0, _array.flatUniqConcat)(state.currentByClient, ...action._rooms)
      });
    case types.ROOM_CURRENT_CLIENT_REMOVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentByClient: state.currentByClient.filter(_room => !action._rooms.includes(_room))
      });
    case types.ROOM_CURRENT_USER_ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: (0, _array.flatUniqConcat)(state.items, ...action._rooms),
        currentByUser: (0, _array.flatUniqConcat)(state.currentByUser, ...action._rooms)
      });
    case types.ROOM_CURRENT_USER_REMOVE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentByUser: state.currentByUser.filter(_room => !action._rooms.includes(_room))
      });
    case types.REMOVE_ROOM:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: state.items.filter(_room => _room !== action._room),
        currentByUser: state.currentByUser.filter(_room => action._room !== _room),
        currentByClient: state.currentByClient.filter(_room => action._room !== _room),
        ringing: state.ringing.filter(_room => action._room !== _room)
      });
    case types.SET_ACTIVE_ROOM:
      return _objectSpread(_objectSpread({}, state), {}, {
        _currentActive: action._room
      });
    case _types2.PURGE_SESSION:
      return (0, _cloneDeep.default)(initialState);
    default:
      return state;
  }
};
var _default = exports.default = roomReducer;
module.exports = exports.default;